module.exports = __webpack_public_path__ + "static/media/html.81befd6a.svg";